module.exports = {
  visibility: false,
  menuEntry: 'addons',
  defaultName: {
    de: 'Zusatzprodukte',
    en: 'Additional products',
    es: 'Productos adicionales',
    fr: 'Produits supplémentaires',
    pt: 'Produtos adicionais',
    it: 'Prodotti supplementari',
    ru: 'Дополнительная продукция'
  },
  title: {
    en: 'Addons',
    de: 'Material',
    es: 'Complementos',
    fr: 'AddOns',
    pt: 'Material',
    it: 'Materiale',
    ru: 'Материал'
  },
  icon: 'inbox',
  iconPrefix: 'fas',
  iconColor: 'white',
  badgeColor: 'gray',
  categoryPicker: true,
  tabs: [
       {
         id: 'addons',
         title: {
           en: 'Addons',
           de: 'Zusatzprodukte',
           es: 'Complementos',
           fr: 'AddOns',
           pt: 'Material',
           it: 'Materiale',
           ru: 'Материал'
         },
         type: 'addons',
         hidePrices: false,
         category: 'chew',
       },
       {
         id: 'cart',
         type: 'cart',
         title: {
           en: 'Cart',
           de: 'Warenkorb',
           es: 'Cesta de la compra',
           fr: 'Panier',
           pt: 'Cesto',
           it: 'Carrello',
           ru: 'Корзина'
         },
         hideOrdered: true,
         requireShipping: false,
         orderDialog: [
           {
             id: 'terms',
             intro: {
               style: 'alert alert-warning',
               en: 'Please confirm your order',
               de: 'Bitte bestätigen Sie Ihre Bestellung',
               es: 'Por favor, confirme su pedido',
               fr: 'Veuillez confirmer votre commande',
               pt: 'Por favor, confirme o seu pedido',
               it: 'Si prega di confermare l`ordine',
               ru: 'Пожалуйста, подтвердите Ваш заказ'
             },
             form: [
               {
                 id: 'terms',
                 type: 'checkbox',
                 checkValue: true,
                 required: true,
                 label: {
                   en: 'I have read and accepted the <a href="https://www.orehab-minds.com/agb/" target="_blank">terms of service</a>.',
                   de: 'Ich habe die <a href="https://www.orehab-minds.com/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert.',
                   es: 'He leído y aceptado las <a href="https://www.orehab-minds.com/agb/" target="_blank">Condiciones Generales</a>.',
                   fr: 'J`ai lu les <a href="https://www.orehab-minds.com/agb/" target="_blank">conditions générales de vente</a> et je les accepte.',
                   pt: 'Li e aceito os <a href="https://www.orehab-minds.com/agb/" target="_blank">termos e condições gerais</a>.',
                   it: 'Ho letto e accetto le <a href="https://www.orehab-minds.com/agb/" target="_blank">condizioni generali di acquisto</a>.',
                   ru: 'Я прочитал(а) и принял(а) <a href="https://www.orehab-minds.com/agb/" target="_blank">Общие условия использования</a>.'
                 }
               },
               {
                 id: 'privacy',
                 type: 'checkbox',
                 required: true,
                 checkValue: true,
                 label: {
                   en: 'I have read and accepted the <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">pricacy policy</a>.',
                   de: 'Ich habe die <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Datenschutzhinweise</a> gelesen und akzeptiert.',
                   es: 'He leído y aceptado la <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Política de Privacidad</a>.',
                   fr: 'J`ai lu les <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">données de protection des données</a> et je les accepte.',
                   pt: 'Li e aceito a <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">política de privacidade</a>.',
                   it: 'Ho letto e accetto <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">l`informativa sulla protezione dei dati personali</a>.',
                   en: 'Я прочитал(а) и принял(а) <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Положения по защите данных</a>.'
                 }
               }
             ]
           }
         ]
       }
     ]
   };
